// Simplified color palette for self-containment and consistency with dark theme

// import TikTokLink from "./TikTokLink";
// import InstagramLink from "./InstagramLink";
// import DiscordLink from "./DiscordLink";

const colors = {
    background: '#0a0a0c',
    container: '#18181b',
    border: '#3f3f46',
    text: '#f4f4f5',
    textMuted: '#a1a1aa',
    ctaPrimary: '#8b5cf6', // Purple/Violet
    tagAccent: '#60a5fa', // Blue
    highlight: '#3f3f46',
    shadow: 'rgba(0, 0, 0, 0.4)',
};

const ContactUs = () => {
    const founderEmail = "contact@flashfluency.net"; 

    return (
        <div
            style={{
                minHeight: '100vh',
                backgroundColor: colors.background,
                color: colors.text,
                display: 'flex',
                flexDirection: 'column',
                fontFamily: 'Inter, sans-serif'
            }}
        >
            {/* Simple Header */}
            <header
                style={{
                    backgroundColor: colors.container,
                    borderBottom: `1px solid ${colors.border}`,
                    padding: '16px',
                }}
            >
                <div className="max-w-4xl mx-auto flex justify-between items-center">
                    <a href="/" className="text-xl font-bold" style={{ color: colors.text }}>
                        Flash Fluency
                    </a>
                    <a href="/" className="text-sm px-3 py-1 rounded-full" style={{ color: colors.textMuted, border: `1px solid ${colors.border}` }}>
                        ← Back to Home
                    </a>
                </div>
            </header>

            {/* Main Content Area */}
            <main className="flex-grow py-16 px-4 md:px-6" style={{ maxWidth: '800px', margin: '0 auto' }}>
                <div
                    style={{
                        padding: '40px',
                        borderRadius: '20px',
                        backgroundColor: colors.container,
                        boxShadow: `0 8px 30px ${colors.shadow}`,
                        border: `1px solid ${colors.border}`,
                        textAlign: 'center',
                    }}
                >
                    {/* <h1 
                        style={{ 
                            fontSize: '32px', 
                            fontWeight: '800', 
                            color: colors.text, 
                            marginBottom: '8px' 
                        }}
                    >
                        A Note from the Founder
                    </h1>
                    
                    <p 
                        style={{ 
                            fontSize: '18px', 
                            fontWeight: '600', 
                            color: colors.tagAccent, 
                            marginBottom: '24px' 
                        }}
                    >
                        Building Flash Fluency for Language Learners
                    </p>

                    <p 
                        style={{ 
                            fontSize: '16px', 
                            color: colors.textMuted, 
                            lineHeight: 1.7, 
                            maxWidth: '600px', 
                            margin: '0 auto 40px' 
                        }}
                    >
                        I am building Flash Fluency because learning Korean felt harder than it needed to be. I was using multiple apps and still couldn't listen confidently or speak naturally.
                    </p>

                    <p 
                        style={{ 
                            fontSize: '16px', 
                            color: colors.textMuted, 
                            lineHeight: 1.7, 
                            maxWidth: '600px', 
                            margin: '0 auto 40px' 
                        }}
                    >
                        My goal is simple: build one system that takes you from Hangul to fluency in a structured, efficient, and personalized way.
                    </p> */}
                    
                    {/* Business Inquiries Section */}
                    <h2 
                        style={{ 
                            fontSize: '24px', 
                            fontWeight: '700', 
                            color: colors.text, 
                            marginBottom: '20px',
                            borderTop: `1px solid ${colors.border}`,
                            paddingTop: '30px'
                        }}
                    >
                        For Business Inquiries
                    </h2>
                    
                    <p 
                        style={{ 
                            fontSize: '16px', 
                            color: colors.textMuted, 
                            lineHeight: 1.7, 
                            maxWidth: '600px', 
                            margin: '0 auto 24px' 
                        }}
                    >
                        For partnerships, press, or business-related questions, reach out via email.
                    </p>

                    <a 
                        href={`mailto:${founderEmail}`}
                        className="hover:opacity-90 transition-opacity"
                        style={{ 
                            display: 'inline-block',
                            padding: '12px 28px', 
                            borderRadius: '999px', 
                            backgroundColor: colors.ctaPrimary, 
                            color: colors.background, 
                            fontSize: '16px', 
                            fontWeight: '700', 
                            textDecoration: 'none',
                            boxShadow: `0 4px 10px ${colors.shadow}`,
                        }}
                    >
                        {founderEmail}
                    </a>

                    {/* <h2 
                        style={{ 
                            fontSize: '24px', 
                            fontWeight: '700', 
                            color: colors.text, 
                            marginTop: '50px',
                            marginBottom: '20px',
                            borderTop: `1px solid ${colors.border}`,
                            paddingTop: '30px'
                        }}
                    >
                        Join Our Community
                    </h2>
                    
                    <p 
                        style={{ 
                            fontSize: '16px', 
                            color: colors.textMuted, 
                            lineHeight: 1.7, 
                            maxWidth: '600px', 
                            margin: '0 auto 24px' 
                        }}
                    >
                        Connect with us on social media for updates, tips, and to share your language learning journey. Drop feedback on Discord — your input helps shape Flash Fluency!
                    </p>

                    <div className="flex justify-center gap-8 pt-2">
                        <DiscordLink />
                        <InstagramLink />
                        <TikTokLink />
                    </div> */}
                </div>
            </main>
        </div>
    );
};

export default ContactUs;
